// features/auth/components/AuthDivider.tsx

import { Separator } from "@/shared/components/ui/separator";

interface AuthDividerProps {
  label: string;
}

export function AuthDivider({ label }: AuthDividerProps) {
  return (
    <div className="flex items-center gap-3 w-full my-5" role="separator">
      <Separator className="flex-1" />
      <span className="text-xs text-muted-foreground select-none">{label}</span>
      <Separator className="flex-1" />
    </div>
  );
}
